"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const react_loops_1 = require("react-loops");
const models_1 = require("@osmosys/models");
const react_if_1 = require("react-if");
const SaveButton_1 = require("./SaveButton");
const constants_1 = require("../../../../constants");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
exports.ConversionCanvasToolbarInner = ({ dispatchCanvasAction, draft, view, }) => {
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.Toolbar, { osysName: "ConversionCanvasToolbarInner" },
        react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarGroup, { osysName: "ConversionCanvasToolbarInner.Left", marginRight: "sm" },
            react_2.default.createElement(react_if_1.If, { condition: view === 'stepsList' },
                react_2.default.createElement(react_if_1.Then, null,
                    react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "ConversionCanvasToolbarInner.runConversion", osysStyle: "toolbar", iconStyle: "solid", osysIcon: "convert", onClick: () => {
                            dispatchCanvasAction({
                                data: {
                                    view: 'runConversion',
                                },
                                type: 'prefs',
                            });
                        }, tooltip: "Run conversion", renderApolloError: true }, "Convert")),
                react_2.default.createElement(react_if_1.Else, null,
                    react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "ConversionCanvasToolbarInner.stepsList", osysStyle: "toolbar", iconStyle: "solid", osysIcon: "edit", onClick: () => {
                            dispatchCanvasAction({
                                data: {
                                    view: 'stepsList',
                                },
                                type: 'prefs',
                            });
                        }, tooltip: "Edit conversion", renderApolloError: true }, "Edit")))),
        react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarGroup, { osysName: "ConversionCanvasToolbarInner.Center", flexRowCenteredFilled: true },
            react_2.default.createElement(react_if_1.When, { condition: view === 'stepsList' }, () => (react_2.default.createElement(react_loops_1.For, { in: constants_1.CONVERSION_STEP_META }, (step, { key: actionType }) => {
                return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: `ConversionCanvasToolbarInner.step.${actionType}`, faIcon: step.icon, tooltip: react_2.default.createElement(react_2.default.Fragment, null,
                        react_2.default.createElement("small", null, "Add conversion step:"),
                        react_2.default.createElement("br", null),
                        react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: step.icon }),
                        ' ',
                        react_2.default.createElement("strong", null, step.displayName)), onClick: () => {
                        const newStep = new models_1.ContentConversionStep();
                        newStep.type = actionType;
                        dispatchCanvasAction({
                            data: {
                                draft: Object.assign(Object.assign({}, draft), { steps: [newStep, ...draft.steps] }),
                            },
                            type: 'state',
                        });
                    } }));
            })))),
        react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarGroup, { osysName: "ConversionCanvasToolbarInner.Right", marginRight: "sm" },
            react_2.default.createElement(SaveButton_1.ConversionCanvasSaveButton, null))));
};
//# sourceMappingURL=Inner.js.map